/** The HouseGap mark, inline so it can take the colour of wherever it sits.
    A roof over three columns (three trackers measuring the same house), and an
    amber cap on the third column: the part it doesn't see. The source files
    are public/img/logo-mark.svg and logo.svg. */
export function Mark({ tone = 'white', size = 22 }: { tone?: 'white' | 'colour'; size?: number }) {
  const fill = tone === 'white' ? '#fff' : 'url(#hg-mark)';
  return (
    <svg viewBox="0 0 48 48" width={size} height={size} aria-hidden focusable="false">
      {tone === 'colour' && (
        <defs>
          <linearGradient id="hg-mark" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#2f55e8" />
            <stop offset="1" stopColor="#8b5cf6" />
          </linearGradient>
        </defs>
      )}
      <polyline points="5,19 24,5 43,19" fill="none" stroke={fill} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="9" y="29" width="8" height="13" rx="2.5" fill={fill} />
      <rect x="20" y="21" width="8" height="21" rx="2.5" fill={fill} />
      <rect x="31" y="27.5" width="8" height="14.5" rx="2.5" fill={fill} />
      <rect x="31" y="21" width="8" height="3.4" rx="1.7" fill="#f2b56b" />
    </svg>
  );
}
